import { Button, Card } from "@blueprintjs/core";
import React from "react";
import { useLanguage } from "../context/LanguageContext";

export const Manual = () => {
    const { t } = useLanguage();

    return (
        <div className="experiment-container" style={{ maxWidth: 620, margin: "0 auto", textAlign: "left" }}>
            <h2 style={{ textAlign: "center", marginBottom: 32 }}>{t('manual', 'title')}</h2>
            <p>
                {t('manual', 'introduction')}
            </p>

            <h3 style={{ marginTop: 24 }}>{t('manual', 'sections', 'howItWorks', 'title')}</h3>
            <ol style={{ marginBottom: 18 }}>
                <li>
                    <b>{t('manual', 'sections', 'howItWorks', 'steps', 'selectExperiment', 'title')}</b> {t('manual', 'sections', 'howItWorks', 'steps', 'selectExperiment', 'content')}
                    <div style={{ margin: "10px 0" }}>
                        <Button icon="lab-test" text={t('manual', 'sections', 'howItWorks', 'buttons', 'startExperiment')} disabled />
                    </div>
                </li>
                <li>
                    <b>{t('manual', 'sections', 'howItWorks', 'steps', 'completeTask', 'title')}</b> {t('manual', 'sections', 'howItWorks', 'steps', 'completeTask', 'content')}
                    <div style={{ display: "flex", gap: 12, margin: "10px 0" }}>
                        <Card interactive={false} elevation={1} style={{ width: 120, textAlign: "center" }}>
                            {t('manual', 'sections', 'howItWorks', 'options', 'optionA')}
                        </Card>
                        <Card interactive={false} elevation={1} style={{ width: 120, textAlign: "center" }}>
                            {t('manual', 'sections', 'howItWorks', 'options', 'optionB')}
                        </Card>
                    </div>
                </li>
                <li>
                    <b>{t('manual', 'sections', 'howItWorks', 'steps', 'nextStep', 'title')}</b> {t('manual', 'sections', 'howItWorks', 'steps', 'nextStep', 'content')}
                    <div style={{ margin: "10px 0" }}>
                        <Button icon="arrow-right" text={t('manual', 'sections', 'howItWorks', 'buttons', 'next')} disabled />
                    </div>
                </li>
                <li>
                    <b>{t('manual', 'sections', 'howItWorks', 'steps', 'viewResults', 'title')}</b> {t('manual', 'sections', 'howItWorks', 'steps', 'viewResults', 'content')}
                    <div style={{ margin: "10px 0" }}>
                        <Button icon="chart" text={t('manual', 'sections', 'howItWorks', 'buttons', 'showResults')} disabled />
                    </div>
                </li>
                <li>
                    <b>{t('manual', 'sections', 'howItWorks', 'steps', 'showExplanation', 'title')}</b> {t('manual', 'sections', 'howItWorks', 'steps', 'showExplanation', 'content')}
                    <div style={{ margin: "10px 0" }}>
                        <Button icon="info-sign" text={t('manual', 'sections', 'howItWorks', 'buttons', 'showExplanation')} disabled />
                    </div>
                </li>

                <li>
                    <b>{t('manual', 'sections', 'howItWorks', 'steps', 'useGlossary', 'title')}</b> {t('manual', 'sections', 'howItWorks', 'steps', 'useGlossary', 'content')}
                    <div style={{ margin: "10px 0" }}>
                        <Button icon="book" text={t('manual', 'sections', 'howItWorks', 'buttons', 'openGlossary')} disabled />
                    </div>
                </li>
            </ol>

            <h3 style={{ marginTop: 24 }}>{t('manual', 'sections', 'navigation', 'title')}</h3>
            <ul>
                <li>
                    {t('manual', 'sections', 'navigation', 'items', 'backToExperiments')}
                </li>
                <li>
                    {t('manual', 'sections', 'navigation', 'items', 'overview')}
                </li>
            </ul>

            <h3 style={{ marginTop: 24 }}>{t('manual', 'sections', 'important', 'title')}</h3>
            <ul>
                <li>{t('manual', 'sections', 'important', 'items', 'noRightWrong')}</li>
                <li>{t('manual', 'sections', 'important', 'items', 'honestOpinion')}</li>
                <li>{t('manual', 'sections', 'important', 'items', 'stepByStep')}</li>
                <li>{t('manual', 'sections', 'important', 'items', 'useGlossaryAnytime')}</li>
            </ul>

            <p style={{ marginTop: 32 }}>
                {t('manual', 'conclusion')}
            </p>
        </div>
    );
};